module.exports = __webpack_public_path__ + "img/ceratostigma-plumbaginoides.506e7ae9.jpg";